import React from 'react';
import './AlertIndicator.css';
import { ALERT_COLORS } from './alertColors';

function AlertIndicator({ level = "normal", message = "狀態正常" }) {
  // 這裡故意用字面色碼（經由 alertColors.js）而不是引用 index.css 的 CSS
  // 變數：inline style 用 var(--...) 在瀏覽器裡沒問題，但測試環境的 CSS 是
  // 被 mock 掉的，jest-dom 的 toHaveStyle 只比對 inline style 字面值，套用
  // 不到變數。色碼本身要跟 index.css 的 --wa-clay-red / --wa-gold /
  // --wa-moss 保持一致，測試檔案也是 import 同一份 ALERT_COLORS，不會各自
  // 寫死副本。
  const getColor = () => {
    switch (level) {
      case "danger":
        return ALERT_COLORS.danger;
      case "warning":
        return ALERT_COLORS.warning;
      case "normal":
      default:
        return ALERT_COLORS.normal;
    }
  };

  return (
    <div className="alert-indicator">
      <div className="light" style={{ backgroundColor: getColor() }} />
      <span className="alert-message">{message}</span>
    </div>
  );
}

export default AlertIndicator;
